<template>
  <div class="sfdocs__navigator">
    <header class="sfdocs__header folder-icon">
      <div class="sfdocs__root-folder">
        <h3 class="sfdocs__root-path align-text-vertically">
          {{ info }} (Related Files)
        </h3>
      </div>
      <nav class="sfdocs__nav">
        <ul>
          <li>
            <router-link tag="button" :to="filesLink"> Back </router-link>
          </li>
        </ul>
      </nav>
    </header>
    <div class="sfdocs__related">
      <div
        v-for="file in relatedFiles"
        :key="file.path"
        @click="openRelatedFiles(file.path)"
        class="related-folder"
      >
        <span class="related-folder__icon"></span>
        <h3 class="related-folder__title">{{ file.displayName }}</h3>
        <h4 class="related-folder__subtitle">{{ file.recordName }}</h4>
      </div>
    </div>
    <PageFooter />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import PageFooter from '@/components/PageFooter';

export default {
  components: { PageFooter },
  name: 'RelatedFiles',
  data() {
    return {};
  },
  computed: {
    ...mapState(['relatedFiles']),
    info() {
      return this.$route.query.info;
    },
    filesLink() {
      return `/${this.$route.params.orgSalesforceId}/${this.$route.params.recordType}/${this.$route.params.recordTypeSalesforceId}?info=${this.$route.query.info}`;
    },
  },
  methods: {
    ...mapActions(['loadRelatedFiles']),
    ...mapMutations({ setRelatedFiles: 'SET_RELATED_FILES' }),
    openRelatedFiles(path) {
      this.$router.push(path);
    },
  },
  beforeMount() {
    this.setRelatedFiles({ relatedFiles: [] });
  },
  async mounted() {
    await this.loadRelatedFiles({
      domain: this.$route.params.recordType,
      entity: this.$route.params.recordTypeSalesforceId,
    });
  },
};
</script>

<style lang="scss" scoped>
.sfdocs__navigator {
  position: relative !important;
}

.related-folder {
  display: flex;
  padding: 10px;
  margin: 10px;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.related-folder__title,
.related-folder__subtitle {
  margin-top: 2px;
  margin-bottom: 2px;
}

.related-folder__icon {
  display: block;
  height: 60px;
  width: 60px;
  background: url('../assets/img/folder-icon.svg') no-repeat center center;
}
</style>
